import styled from 'styled-components';

export const FlowContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px;
  border: 1px solid rgb(0 0 0 / 6%);
  border-radius: 4px;
`;
